<div class="container-fluid top-bar ds-top-nav-bar" id="top-bar">
  <div class="parent-nav-bar">
    <nav class="navbar navbar-expand-lg">
      <div class="container-fluid">
        <div class="collapse navbar-collapse" id="navbarText">
          <div class="left-menu__options" id="top-left-menu-guide" [ngClass]="{'disabled': isFinanceManager && isBasicFunctionPurchased && isSelfSetupOn && selfSetupPercentage != 100}">
            @if(isClaimOnWebAllowed){<app-common-dropdown
              [dropdownLabel]="'claim' | translate : param"
              [dropdownRoute]="
                isDelegateFunctionPurchasedOrTrial && isDelegate
                  ? ['/claimant/delegatorsexpense']
                  : ['/claimant/expenselist']
              "
              [dropdownItems]="claimDropdownItems"
              (itemSelected)="onClaimDropdownItemSelected($event)"
              [activeClass]="
                routeIsActive('/claimant') ||
                routeIsActive('/orgsetting/claimantfcdashboard')"
              >
            </app-common-dropdown>}
            @if((isClaimOnWebAllowed && (claims?.orgRoleId == 2 || claims?.orgRoleId == 3))){<app-common-dropdown 
              [dropdownLabel]="'approval_route' | translate : param"
              [dropdownRoute]="['/approver/appclaimant', 1]"
              [dropdownItems]="approverDropdownItems"
              (itemSelected)="onApproverDropdownItemSelected($event)"
              [activeClass]="routeIsActive('/approver')"
              >
            </app-common-dropdown>}
            @if(twoStepApproval && isFinanceManager && isFinanceApprovalAccess){<app-common-dropdown
              [dropdownLabel]="'finance_approval' | translate : param"
              [dropdownRoute]="['/financeapprover/faexpenses', 1]"
              [dropdownItems]="financeApprovalDropdownItems"
              (itemSelected)="onFinanceApprovalDropdownItemSelected($event)"
              [activeClass]="routeIsActive('/financeapprover')">
            </app-common-dropdown>}
            @if(twoStepApproval && isFinanceManager && isPayAccess && isPayStepEnabled){<app-common-dropdown
              [dropdownLabel]="'pay' | translate : param"
              [dropdownRoute]="['/pay/payexpenses', 1]"
              [dropdownItems]="payDropdownItems"
              (itemSelected)="onPayDropdownItemSelected($event)"
              [activeClass]="routeIsActive('/pay')">
            </app-common-dropdown>}
            @if(this.claims.isAPAutomationFunctionPurchasedOrTrial 
         &&(claims.orgRoleId == 3 || claims.orgRoleId == 2 || (claims.orgRoleId == 1 
          && claims.CanCreateRequisition))){<app-common-dropdown 
              [dropdownLabel]="'vendor_v1_msg41' | translate : param"
              [dropdownRoute]="['/vendorweb/vendorredirect']"
              (dropdownSelected)="onVendorDropdownItemSelected($event)"
              [dropdownItems]="buildVendorDropdownItems"
              (itemSelected)="onVendorDropdownItemSelected($event)"
              [activeClass]="routeIsActive('/vendorweb')">
            </app-common-dropdown>}
            @if(isFinanceManager && isCardSetupComplete && isCardAccess && manageCCOptions != 2){<app-common-dropdown 
              [dropdownLabel]="'cards' | translate : param"
              [dropdownRoute]="['/universalimport/ccuploadfile']"
              [dropdownItems]="cardsDropdownItems"
              (itemSelected)="onCardsDropdownItemSelected($event)"
              [activeClass]="isCardMenuActive()">
            </app-common-dropdown>}
            @if(isFinanceManager && isAccExportAccess){<app-common-dropdown 
              [dropdownLabel]="'accounting_export' | translate : param"
              [dropdownRoute]="['/export/expenseexport']"
              [dropdownItems]="accountingExportDropdownItems"
              (itemSelected)="onAccountingExportDropdownItemSelected($event)"
              [activeClass]="routeIsActive('/export')">
            </app-common-dropdown>}
          </div>
          <div class="right-menu__options nav-web-ph">
            <!-- button will be used for ExA AI integration -->
            <button hidden id="exa-btn" class="exa-ai-button"><img [src]="ICONS.EXA_AI" alt="">{{'talk_to_exa' | translate}}</button>
            @if(isPrimaryFM){<div class="dashboard-menu-icon__container"  [ngClass]="{'disabled': isBasicFunctionPurchased && isSelfSetupOn && selfSetupPercentage != 100}">
              <img id="fun-cart" 
                [routerLink]="['/shoppingcartlist']"
                class="icon-link" [src]="ICONS.SHOPPING_CART" alt="">
              <span id="notifications-counter" class="notification-counter">{{ CartCount }}</span>
            </div>}
            <div class="dashboard-menu-icon__container">
              <img id="fullscreen-btn" class="icon-link" (click)="fullscreen()" [src]="isInFullscreenMode ? ICONS.FULL_SCREEN_EXIT : ICONS.FULL_SCREEN_ENTER" alt="">
            </div>
            <div class="dashboard-menu-icon__container">
              <img id="notifications-btn" [ngClass]="{ ring: notificationsCount > 0 }" (click)="isNotificationPanelActive = true" [src]="ICONS.BELL_ICON" alt="">
              @if(notificationsCount){<span id="notifications-counter" class="notification-counter"> {{ notificationsCount }} </span>}
            </div>
            <div class="dashboard-menu__profile"  id="profile-link-guide">
              <img id="profile-link" class="profile__icon" [routerLink]="['/profilemenu']" [src]="ICONS.USER_SOLID" alt="">
            </div>
          </div>
        </div>
      </div>
    </nav>


    <nav class="navbar navbar-expand-lg" style="height: 60px" hidden>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation">
        <span class="dark-blue-text"><i class="fas fa-bars fa-1x"></i></span>
      </button>
      <div
        class="collapse navbar-collapse d-flex justify-content-between"
        id="navbarSupportedContent">
        @if(claims.orgRoleId != 3){<div
          class="navbar-brand-box"style="background: white; min-width: 190px; height: 60px">
          <a
            href="javascript: void(0)"
            class="logo logo-light d-flex justify-content-center"
            style="width: 160px; height: 55px; padding: 3px">
            <img [src]="imageSource" alt="" height="23" width="170px" />
          </a>
        </div>}
      </div>
 
    </nav>
  </div>
  @if(showLoginMarquee && marqueeText && marqueeText != '' && !activatePricingMenu){<div id="marquee">
    <marquee behavior="scroll" direction="left" scrollamount="8">
      <i class="fas fa-exclamation-triangle pr-2 eod-text-danger"></i>
      <span [innerHTML]="sanitizerHtml(marqueeText)"></span>
    </marquee>
  </div>}
</div>
<div class="clear"></div>

@if(showExportReportMarketingPopup){<div class="overLayDiv active"></div>}

<!-- Data Export -->
<div id="rightSideBar">
  @if(showExportReportMarketingPopup){<div
    class="rightSidePanel d-flex flex-column">
    <header class="panel-header">
      <div class="viewDemo title-and-video">
        <img src="../../../assets/svg-icons/paid-function-LR.svg" class="svg-50" />
        <h2>{{ "data_transfer_to_other_systems_build_your_own_report" | translate : param }}</h2>
      </div>            
      <div class="panel-left-btn">
          <button type="button" class="btn eod-btn-outline-warning" (click)="fnCloseExportReportMarketingPopUp()">
            {{ 'Close' | translate }}
          </button>
      </div>
    </header>

    <div class="eod-panel-body-with-footer" id="liability-report">
      <div class="block height-465px">
        <h6 class="text-uppercase f-14 font-weight-bold pb-3 border-bottom ">
          {{ "transfer_data_and_build_reports" | translate : param }}
        </h6>
        <div class="row margin-top-0">
          <div class="col-lg-7 no-padding-right-left">
            <img
              src=".../../../assets/svg-icons/build-report-image.svg"
              class="height-auto position-absolute left-0 top-20px" />
          </div>

          <div class="col-lg-5 padding-right-0 padding-top-50">
            <div class="row">
              <div
                class="box-shadow bg-grey-1 padding-15 color-black font-weight-normal w-100pc">
                {{
                  "build_your_own_reports_for_analysis_and_built_formats_to_transfer_data_to_any_accounting_system"
                    | translate : param
                }}
                <h6
                  class="margin-top-15 font-weight-bold color-green text-uppercase text-center">
                  {{
                    "liabilityReport_available_for_trial_now"
                      | translate : param
                  }}
                </h6>
              </div>
            </div>
            <div class="row margin-top-25">
              <p
                (click)="zoomDataExportImage()"
                class="import-summary-info w-100pc margin-all-0 height-auto cursor-pointer padding-0 border-radius-1 position-relative"
                id="viewReceipt">
                <img
                  src="/assets/images/create-report.png"
                  class="border-radius-1" />
                <span class="enlarge-img">
                  <i class="fas fa-search-plus" style="color: #30a5cf"></i>
                </span>
                <span class="text f-13"> </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer class="mt-auto py-1 d-flex justify-content-center align-items-center gap-2 height-60px">
      <button type="button" class="btn eod-btn-primary" (click)="routerNavigateToExportData()">
        {{ "label_watch_video" | translate : param }}
      </button>
      <button type="button" class="btn eod-btn-primary" (click)="fnSaveCartDetailsForExportReport()"
        [ngClass]="{ disabled: disableAddToCartForDataExport }"
        [disabled]="disableAddToCartForDataExport">
        {{ "add_to_cart" | translate : param }}
      </button>
    </footer>
  </div>}
</div>

@if(showZoomedDataExportImage){<div class="overLayDiv active"></div>}
@if(showZoomedDataExportImage){<div
  class="modal modal-lg fade lR-modal-popup show"
  style="display: block"
  id="viewReceiptModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="{{ 'Close' | translate }}"
          (click)="closeDataExportImage()">
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title" id="viewReceiptLabel">
          {{
            "data_transfer_to_other_systems_build_your_own_report"
              | translate : param
          }}
        </h4>
      </div>
      <div class="modal-body position-relative">
        <div class="imgContainer height-auto">
          <span class="d-block text-center"
            ><img src="/assets/images/create-report.png" class="mx-auto"
          /></span>
        </div>
      </div>
    </div>
  </div>
</div>}

@if(showQRCodePanel){<div class="overLayDiv active"></div>}
@if(showQRCodePanel){<div id="rightSideBar" style="display: block">
  <div class="rightSidePanel onboard-complete-panel active">
    <header class="panel-header">
      <div class="viewDemo title-and-video">
          <h2>{{ "download_free_trial_msg" | translate }}</h2>
      </div>
    </header>
    <div class="clear"></div>
    <div class="block mt-0 padding-bottom-15 overflow-hidden heightCalc-10">
      <div class="row bg-white padding-top-0">
        <h6 class="border-bottom w-100pc padding-bottom-10 fw-600 f-22">
          {{ "onboarding_scan_qr_codes" | translate }}
        </h6>
      </div>
      <div class="row">
        <div class="col-md-6 no-padding-right-left text-right">
          <span
            ><img
              alt=""
              src="../../assets/images/web-mobile-1920w.png"
              class="heightCalc-21"
          /></span>
        </div>
        <div class="col-md-6 margin-top-30 padding-top-50">
          <div class="d-flex justify-content-center flex-column">
            <div>
              <span class="d-block text-center"
                ><img
                  alt=""
                  src="../../assets/images/qr-code.png"
                  class="w-55pc"
              /></span>
            </div>
            <div class="d-flex justify-content-center flex-row">
              <span class="margin-top-10 d-block">
                <a href="{{ storeURL.playStore }}" target="_blank"
                  ><img
                    alt=""
                    src="../../assets/images/android-app-download-button.png"
                    class="w-92pc" /></a
              ></span>
              <span class="margin-top-10 d-block">
                <a href="{{ storeURL.appStore }}" target="_blank"
                  ><img
                    alt=""
                    src="../../assets/images/iphone-app-download-button.png"
                    class="w-92pc" /></a
              ></span>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <span class="text-center w-100pc d-block"
          ><button class="btn btn-primary" (click)="closeQRCodePanel()">
            {{ "close" | translate }}
          </button></span
        >
      </div>
    </div>
  </div>
</div>}

<notification-panel
  [hidden]="!isNotificationPanelActive"
  (notificationsCountChange)="onNotificationsCountChange($event)"
  (closePanel)="closeNotificationPanel()"
  (openPanel)="openNotificationPanel()">
</notification-panel>

@if(this.isOrgBasicFunctionTrialEndsAlert){<trial-end-alert-panel>
</trial-end-alert-panel>}

@if(recallExportedExpensesMarketingPopup){<marketing-popup
  [data]="recallExportedExpensesMarketingPopupModel"
  (closePanel)="closeMarketingPopup()">
</marketing-popup>}


@if(showMFAPanel){<div class="overLayDiv active"></div>}
<div id="rightSideBar">
  @if(showMFAPanel){<div class="rightSidePanel active w-40pc">
    <header class="panel-header">
      <div class="viewDemo title-and-video">
          <h2>{{ "multifactor_authentication" | translate }}</h2>
      </div>            
      <div class="panel-left-btn">
          <button type="button" class="btn eod-btn-primary mr-2" (click)="registerNewMFADevice()">
            {{ "Re-register" | translate }}
          </button>
          <button type="button" class="btn eod-btn-outline-warning" (click)="showMFAPanel = false">
            {{ "label_close" | translate }}
          </button>
      </div>
    </header>
    <div class="block mt-2">
      @if(isMFADeviceRegistered){<div>
        <h6 class="info-text">
          <i class="fas fa-exclamation-circle text-mustard"></i>
          <span>{{
            "disable_or_remove_2fa"
              | translate
          }}</span>
        </h6>
        <h6 class="info-text">
          <i class="fas fa-exclamation-circle text-mustard"></i>
          <span>{{
            "scan_new_qr_code_with_authenticator_app" | translate
          }}</span>
        </h6>
        <h6 class="info-text">
          <i class="fas fa-exclamation-circle text-mustard"></i>
          <span>{{
            "enter_new_6_digit_code" | translate
          }}</span>
        </h6>
        <h6 class="info-text">
          <i class="fas fa-exclamation-circle text-mustard"></i>
          <span>{{ "access_the_app" | translate }}</span>
        </h6>
      </div>}
    </div>
    @if(!isMFADeviceRegistered){<div class="block">
      <h6 class="info-text">
        <span class="fw-600 min-w-4em">{{ "step_1" | translate }}</span>
        <span>{{ "scan_below_qr_code_with_authenticator_app" | translate }}</span>
      </h6>
      <div class="border-bottom mb-2">
        <h6 class="info-text mb-0 border-0">
          <span class="fw-600 min-w-4em">{{ "step_2" | translate }}</span>
          <span>{{ "add_account_by_scanning_qr_code" | translate }}</span>
        </h6>
        <div class="d-flex justify-content-center mb-2">
          <img
            [src]="qrCodeUrl"
            alt="Scan QR code with your authenticator app" />
        </div>
      </div>
      <h6 class="info-text border-0">
        <span class="fw-600 min-w-4em">{{ "step_3" | translate }}</span>
        <span>{{ "enter_six_digit_code" | translate }}</span>
      </h6>
      <input
        type="text"
        class="form-control form-input mb-2"
        [(ngModel)]="qrToken" />

      <div class="row">
        <div
          class="d-flex justify-content-center align-items-center mt-3 mr-20 ml-20 position-relative">
          <div class="d-flex w-60pc">
            <input
              type="text"
              class="form-control"
              (input)="onTokenChange($event.target.value)"
              [(ngModel)]="qrToken"
              placeholder="Enter code from authenticator app" />
            <button
              (click)="verifyToken()"
              class="btn btn-primary height-38px f-13 margin-left-25">
              {{ "Verify" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>}
  </div>}
</div>

  <app-alert-panel [data]="alertPanelModel"
                   (callbackEvent)="alertPanelReceiver($event)"></app-alert-panel>

@if(showUnsubscribeNotificationPanel){<notification-unsubscribe-panel>
</notification-unsubscribe-panel>}